function convertMainOutputControlToBoolean(value) {
    return value === "ON";
}

function convertBooleanToMainOutputControl(value) {
    return value ? "ON" : "OFF";
}

export {
    convertMainOutputControlToBoolean,
    convertBooleanToMainOutputControl
}